import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  IconButton,
  Menu,
  MenuItem,
  MenuProps,
  TableCell,
  styled,
} from "@mui/material";
import { MouseEventHandler, useState } from "react";

import type { TableAction } from "../types";

type Props<TRow extends object> = {
  actions?: TableAction<TRow>[];
  rowData: TRow;
};

export function TableRowActions<TRow extends object>({
  actions,
  rowData,
}: Props<TRow>) {
  const [menuEl, setMenuEl] = useState<HTMLElement | null>(null);

  const onIconClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.stopPropagation();
    setMenuEl(event.currentTarget);
  };

  const onCloseClick: MenuProps["onClose"] = (event) => {
    (event as FIXME).stopPropagation();
    setMenuEl(null);
  };

  const onActionClick = (
    event: FIXME,
    handleClick: (rowData: object) => void,
  ) => {
    event.stopPropagation();

    handleClick(rowData);

    setMenuEl(null);
  };

  if (Array.isArray(actions) === false) {
    return null;
  }

  const filtered = actions.filter((action) => {
    if ("isVisible" in action && typeof action.isVisible === "function") {
      return action.isVisible(rowData);
    }

    return true;
  });

  if (filtered.length === 0) {
    return <TableCell />;
  }

  return (
    <TCell>
      <IconButton aria-label="open menu" onClick={onIconClick} size="large">
        <MoreHorizIcon fontSize="small" />
      </IconButton>
      <Menu
        keepMounted
        anchorEl={menuEl}
        open={Boolean(menuEl)}
        onClose={onCloseClick}
      >
        {filtered.map((action) => {
          if ("label" in action) {
            return (
              <MenuItem
                key={action.id}
                onClick={(event) => onActionClick(event, action.handleClick)}
              >
                {action.label}
              </MenuItem>
            );
          }
          return null;
        })}
      </Menu>
    </TCell>
  );
}

const TCell = styled(TableCell)(({ theme }) => ({
  textAlign: "right",
  opacity: 1,
  padding: theme.spacing(0, 2),
  transition: theme.transitions.create(["opacity"], {
    duration: theme.transitions.duration.complex,
  }),
}));
